// Elastic switch knob (Hamza 2026-10-12, option B "elastic + bounce"): while the knob travels it stretches into a pill
// (round ends kept — width grows, corners never scale), flattens a little, overshoots and springs back.
// Drives CSS vars on the element whose ::before is the knob; CSS (base.css / gift-wrap HOST_CSS) reads them while .bjo-ek is on.
(function () {
  if (window.bjoElastic) return;
  var D = 23, TRAVEL = 19, K = 300, C = 15, GAIN = 0.06, SQUASH = 0.22, MAXS = D * 0.75;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(el, on) {
    if (reduce || !el) return;
    if (el.__ek) cancelAnimationFrame(el.__ek.raf);
    var st = el.__ek || { p: on ? 0 : TRAVEL, v: 0 };
    st.target = on ? TRAVEL : 0;
    var dir = getComputedStyle(el, '::before').left === 'auto' ? -1 : 1, last = performance.now(); // knob pinned right (registry in Arabic) travels left; the gift wrap app keeps its knob on the left even in Arabic
    el.__ek = st;
    el.classList.add('bjo-ek');
    (function step(t) {
      var dt = Math.min(0.032, (t - last) / 1000); last = t;
      st.v += (-K * (st.p - st.target) - C * st.v) * dt;
      st.p += st.v * dt;
      var s = Math.min(MAXS, Math.abs(st.v) * GAIN), h = D * (1 - SQUASH * (s / MAXS));
      var lead = Math.max(-2, st.p - (st.v > 0 ? s : 0));               // stretch trails behind the direction of travel
      el.style.setProperty('--ek-tx', dir * lead + 'px');
      el.style.setProperty('--ek-ty', (D - h) / 2 + 'px');
      el.style.setProperty('--ek-w', D + s + 'px');
      el.style.setProperty('--ek-h', h + 'px');
      if (Math.abs(st.v) < 2 && Math.abs(st.p - st.target) < 0.15) {    // at rest: hand back to the normal on/off CSS
        el.classList.remove('bjo-ek'); el.__ek = null; return;
      }
      st.raf = requestAnimationFrame(step);
    })(last);
  }
  window.bjoElastic = run;

  // registry switches (light DOM): <input> + .bjo-switch__track whose ::before is the knob
  document.addEventListener('change', function (e) {
    var i = e.target, tr = i && i.nextElementSibling;
    if (i && i.type === 'checkbox' && tr && tr.classList && tr.classList.contains('bjo-switch__track')) run(tr, i.checked);
  }, true);

  // gift wrap app switch (inside its shadow DOM): the checkbox itself draws the knob with ::before
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var host = path.find(function (n) { return n.localName === 'wrapped-extension'; });
    if (!host || !path.some(function (n) { return n.localName === 'gift-block-launcher'; })) return;
    var box = host.shadowRoot && host.shadowRoot.querySelector('gift-block-launcher input[type="checkbox"]');
    if (!box) return;
    // the checkbox has already flipped when this runs; read the settled state a tick later and animate into it
    // product page: the checkbox is the truth; cart (whole-order wrap): the app shows "on" via its expanded attribute, set a moment later
    var cart = host.getAttribute('target-group') === 'cart-page';
    setTimeout(function () { run(box, cart ? host.getAttribute('expanded') === 'true' : box.checked); }, cart ? 40 : 0);
  }, true);
})();
